import React from 'react';
import { useForm } from '../../context/FormContext';
import { Briefcase, Clock, UserCheck, Home, Heart, GraduationCap, BadgeCheck, Shield } from 'lucide-react';

const EMPLOYMENT_STATUSES = [
  { id: 'Full-Time Employment', label: 'Full-Time Employment', icon: Briefcase },
  { id: 'Part-Time Employment', label: 'Part-Time Employment', icon: Clock },
  { id: 'Self-Employed', label: 'Self-Employed', icon: UserCheck },
  { id: 'Temporary/Contract', label: 'Temporary/Contract', icon: Clock },
  { id: 'Retired', label: 'Retired', icon: Home },
  { id: 'Homemaker', label: 'Homemaker', icon: Home },
  { id: 'Carer', label: 'Carer', icon: Heart },
  { id: 'Education', label: 'Education', icon: GraduationCap },
  { id: 'Benefits', label: 'Benefits', icon: BadgeCheck },
  { id: 'Armed Forces', label: 'Armed Forces', icon: Shield },
];

export const EmploymentStatusStep = ({ onAutoAdvance }) => {
  const { formData, updateFormData } = useForm();

  const handleSelect = (status) => {
    const updates = { employment_status: status.id };

    // Keep employment_history[0].employment_status in lockstep with the top-level
    // selection. Without this, an OCR-pre-populated history entry with a stale
    // status (e.g. "Full-Time Employment") would win at the backend and Artis
    // would receive EmploymentStatus=1 instead of the user's actual choice.
    const existingHistory = formData.employment_history || [];
    const newHistory = existingHistory.length > 0
      ? [...existingHistory]
      : [{ employer: '', job_title: '', employment_status: '', years: 0, months: 0 }];
    newHistory[0] = { ...newHistory[0], employment_status: status.id };

    // Auto-populate "Self Employed" as the employer name if user hasn't set one
    if (status.id === 'Self-Employed' && !formData.employer) {
      updates.employer = 'Self Employed';
      if (!newHistory[0].employer) {
        newHistory[0].employer = 'Self Employed';
      }
    }

    updates.employment_history = newHistory;
    updateFormData(updates);
    setTimeout(() => onAutoAdvance?.(), 300);
  };

  return (
    <div className="space-y-6" data-testid="employment-status-step">
      <div className="text-center">
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Employment
        </h2>
        <p className="text-slate-600 hidden md:block">What is your employment status?</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {EMPLOYMENT_STATUSES.map(status => {
          const Icon = status.icon;
          return (
            <button
              key={status.id}
              onClick={() => handleSelect(status)}
              className={`p-4 rounded-xl border-2 transition-all flex flex-col items-center gap-2 ${
                formData.employment_status === status.id
                  ? 'brand-border brand-bg-light brand-text'
                  : 'border-slate-200 hover:border-slate-300 text-slate-700'
              }`}
              data-testid={`employment-status-${status.id.toLowerCase().replace(/[\s/]/g, '-')}`}
            >
              <Icon className="w-6 h-6" />
              <span className="text-sm font-medium text-center">{status.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EmploymentStatusStep;
